const calpak = window.calpak

const cart = function (t) {
    "use strict";

    function u() {
        return JSON.parse(JSON.stringify({
            credentials: "same-origin",
            headers: {"X-Requested-With": "XMLHttpRequest", "Content-Type": "application/json;"}
        }))
    }

    function a(t, e) {
        return fetch(t, e).then(function (t) {
            if (!t.ok) throw t;
            return t.json()
        })
    }

    function e() {
        return a("/cart.js", u())
    }

    function r(t, e) {
        var r = u();
        return e = e || {}, r.method = "POST", r.body = JSON.stringify({
            line: t,
            quantity: e.quantity,
            properties: e.properties
        }), a("/cart/change.js", r)
    }

    function n(t) {
        var e = u();
        return e.method = "POST", e.body = JSON.stringify(t), a("/cart/update.js", e)
    }

    function i(t) {
        if ("string" != typeof t || 2 !== t.split(":").length) throw new TypeError("Theme Cart: Provided key value is not a string with the format xxx:xxx")
    }

    function c(t) {
        if ("number" != typeof t || isNaN(t)) throw new TypeError("Theme Cart: Variant ID must be a number")
    }

    function o(t) {
        if ("object" != typeof t) throw new TypeError("Theme Cart: Options must be an object");
        if (void 0 === t.quantity && void 0 === t.properties) throw new Error("Theme Cart: You muse define a value for quantity or properties");
        void 0 !== t.quantity && function (t) {
            if ("number" != typeof t || isNaN(t)) throw new TypeError("Theme Cart: An object which specifies a quantity or properties value is required")
        }(t.quantity), void 0 !== t.properties && function (t) {
            if ("object" != typeof t) throw new TypeError("Theme Cart: Properties must be an object")
        }(t.properties)
    }

    function f(n) {
        return i(n), e().then(function (t) {
            var r = -1;
            return t.items.forEach(function (t, e) {
                r = t.key === n ? e + 1 : r
            }), -1 === r ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : r
        })
    }

    function s() {
        return e().then(function (t) {
            return t.attributes
        })
    }

    function h(t) {
        return n({attributes: t})
    }

    return t.getState = function () {
        return e()
    }, t.getItemIndex = f, t.getItem = function (r) {
        return i(r), e().then(function (t) {
            var e = null;
            return t.items.forEach(function (t) {
                e = t.key === r ? t : e
            }), null === e ? Promise.reject(new Error("Theme Cart: Unable to match line item with provided key")) : e
        })
    }, t.addItem = function (t, e) {
        return e = e || {}, c(t), r = t, n = e.quantity, i = e.properties, (o = u()).method = "POST", o.body = JSON.stringify({
            id: r,
            quantity: n,
            properties: i
        }), a("/cart/add.js", o);
        var r, n, i, o
    }, t.addItemFromForm = function (t) {
        !function (t) {
            if (!(t instanceof HTMLFormElement)) throw new TypeError("Theme Cart: Form must be an instance of HTMLFormElement")
        }(t);
        var e, r, n = new FormData(t);
        return c(parseInt(n.get("id"), 10)), e = n, delete (r = u()).headers["Content-Type"], r.method = "POST", r.body = e, a("/cart/add.js", r)
    }, t.updateItem = function (t, e) {
        return i(t), o(e), f(t).then(function (t) {
            return r(t, e)
        })
    }, t.removeItem = function (t) {
        return i(t), f(t).then(function (t) {
            return r(t, {quantity: 0})
        })
    }, t.clearItems = function () {
        return (t = u()).method = "POST", a("/cart/clear.js", t);
        var t
    }, t.getAttributes = s, t.updateAttributes = h, t.clearAttributes = function () {
        return s().then(function (t) {
            for (var e in t) t[e] = "";
            return h(t)
        })
    }, t.getNote = function () {
        return e().then(function (t) {
            return t.note
        })
    }, t.updateNote = function (t) {
        return n({note: t})
    }, t.clearNote = function () {
        return n({note: ""})
    }, t.getShippingRates = function () {
        return a("/cart/shipping_rates.json", u())
    }, t
}({});
calpak.cart = cart
